<template>
    <div>
        <!-- 标题 -->
        <div class="approvalTaskDetail-title">
            <Breadcrumb>
                <BreadcrumbItem>{{$t('ApprovalTask.approvalFlowName')}}</BreadcrumbItem>
                <BreadcrumbItem to="/approvalTask">{{$t('ApprovalTask.title')}}</BreadcrumbItem>
            </Breadcrumb>
        </div>
        <Row style="margin-bottom: 15px;">
            <Col span="24">
                <Card style="padding:47px;">
                    <Steps :current="current" size="small" style="margin-top: 37px;" >
                        <Step :title="item.title" v-for="(item,index) in stepsData" v-bind:key="index" content="这里是该步骤的描述信息"></Step>
                    </Steps>
                </Card>
            </Col>
        </Row>
        <Row>
            <Col span="24">
                <Card>
                    <p slot="title" style="font-size: 13px;">{{$t('ApprovalTask.processInformation')}}</p>
                    <div class="approvalTask-main" v-for="item in processInstanceNodes" style="padding-left:63px;padding-top:40px;">
                        <div v-if="item.name!='开始'&&item.name!='结束'">
                            <Row>
                                <Col span="6">{{item.approveUserName}}</Col>
                                <div v-if="item.status!=undefined">
                                    <Col span="12">{{$t('ApprovalTask.approvalStatus')}}:{{item.status}}</Col>
                                </div>
                            </Row>
                            <p>{{$t('ApprovalTask.startTime')}}:{{item.createTime}}</p>
                            <p>{{$t('ApprovalTask.endTime')}}:{{item.endTime}}</p>
                        </div>
                    </div>
                </Card>
            </Col>
        </Row>
    </div>
</template>

<script>
    export default {
        name: 'ApprovalTaskDetail',
        data(){
            return {
                current:3,
                stepsData: [],
                processInstanceNodes:[]
            }
        },
        mounted: function(){
            this.approvalDetail();
        },
        methods: {
            approvalDetail: function(){
                this.$api.processTask.approvalDetail({
                    "processTaskId":this.$route.query.id
                })
                .then(res => {
                    this.current=res.data.current;
                    this.stepsData=res.data.stepsData;
                    this.processInstanceNodes=res.data.processInstanceNodes;
                })
            },
        }
    }
</script>

<style scoped>
    .approvalTaskDetail-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 15px 4px;
        font-weight: 600;
    }
    .ivu-breadcrumb {
        font-size: 13px;
        font-weight: 600;
        color: #515a6e;
    }
    .approvalTask-main
    {
        width: 100%;
    }
    .approvalTask-main>div
    {
        border-bottom: 1px solid #e8eaec;
        font-size: 13px;
        color: #000;
        height: 90px;
    }
    .approvalTask-main>div:last-child
    {
        border-bottom: none;
        font-size: 13px;
        color: #000;
        margin-bottom: 0px;
    }
    .ivu-steps.ivu-steps-small>>>.ivu-steps-content
    {
        color:#fff;
    }
</style>



// WEBPACK FOOTER //
// src/components/approval_task/approval_task/ApprovalTaskDetail.vue